import type { EfficacyStatsProps } from 'components/global/EfficacyStats';

export const EFFICACY_STATS: EfficacyStatsProps = {
  stats: [
    { amount: '4M+', label: 'served' },
    { amount: '9k+', label: '5 star reviews', superscriptSymbol: '▵' },
    { amount: '93%', label: 'report effective*' },
  ],
};
